mutation SendSharedInboxVerificationEmail($input: SharedInboxVerificationEmailSendInput!) {
    sharedInboxVerificationEmailSend(input: $input) {
        success
        errorMessage
    }
}
